/* eslint-disable */
import PropTypes from 'prop-types';
import AuthService from '../../Services/Auth/Auth.service';
import MockAuthService from '../../Services/Auth/Auth.service.mock';
import DeliveryService from '../../Services/Delivery/Delivery.service';
import MockDeliveryService from '../../Services/Delivery/Delivery.service.mock';
import EntityService from '../../Services/Entity/Entity.service';
import HttpService from '../../Services/Http/Http.service';
import MockHttpService from '../../Services/Http/Http.service.mock';
import I18nService from '../../Services/I18n/I18n.service';
import OrderService from '../../Services/Order/Order.service';
import MockOrderService from '../../Services/Order/Order.service.mock';
import StorageService from '../../Services/Storage/Storage.service';
import UserService from '../../Services/User/User.service';
import MockUserService from '../../Services/User/User.service.mock';

/**
 * The `Services`
 */
const services = PropTypes.shape({
  /**
   * The `AuthService`
   */
  authService: PropTypes.oneOfType([PropTypes.instanceOf(AuthService), PropTypes.instanceOf(MockAuthService)]).isRequired,

  /**
   * The `DeliveryService`
   */
  deliveryService: PropTypes.oneOfType([PropTypes.instanceOf(DeliveryService), PropTypes.instanceOf(MockDeliveryService)]).isRequired,

  /**
   * The `EntityService`
   */
  entityService: PropTypes.instanceOf(EntityService).isRequired,

  /**
   * The `HttpService`
   */
  httpService: PropTypes.oneOfType([PropTypes.instanceOf(HttpService), PropTypes.instanceOf(MockHttpService)]).isRequired,

  /**
   * The `I18nService`
   */
  i18nService: PropTypes.instanceOf(I18nService).isRequired,

  /**
   * The `OrderService`
   */
  orderService: PropTypes.oneOfType([PropTypes.instanceOf(OrderService), PropTypes.instanceOf(MockOrderService)]).isRequired,

  /**
   * The `StorageService`
   */
  storageService: PropTypes.instanceOf(StorageService).isRequired,

  /**
   * The `UserService`
   */
  userService: PropTypes.oneOfType([PropTypes.instanceOf(UserService), PropTypes.instanceOf(MockUserService)]).isRequired,
});

const ServicesContextPropTypes = {
  /**
   * The `Services`
   */
  services,
};

export default ServicesContextPropTypes;
